import React from "react";
import { Modal, Button } from "react-bootstrap";

const SuccessModal = ({ show, onHide, message, title = "Success!" }) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      backdrop="static"
      keyboard={false}
      size="lg"
    >
      <Modal.Header closeButton className="border-0 pb-0">
        <Modal.Title className="text-success fw-bold">
          <i className="fas fa-check-circle me-2"></i>
          {title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center py-4">
        <div className="mb-4">
          <div className="success-icon-wrapper mb-3">
            <i
              className="fas fa-check-circle text-success"
              style={{ fontSize: "4rem" }}
            ></i>
          </div>
          <h5 className="text-success mb-3">Message Delivered!</h5>
          <p className="lead mb-0 text-muted">{message}</p>
        </div>

        <div className="bg-light p-3 rounded">
          <small className="text-muted">
            <i className="fas fa-info-circle me-2"></i>
            You will receive a confirmation email shortly.
          </small>
        </div>
      </Modal.Body>
      <Modal.Footer className="border-0 pt-0">
        <Button variant="success" size="lg" onClick={onHide} className="px-4">
          <i className="fas fa-thumbs-up me-2"></i>
          Continue
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SuccessModal;
